import AppError from "./AppError";

/**
 * Parses the post part of a document. Uses the supplied doc
 */
export default class PostsParser {
  constructor(
    private doc: Document | HTMLElement,
    private postsSelector: string,
    private postSelector: string
  ) {}

  /**
   * Checks if the document has the posts container
   */
  public hasPostsContainer(): boolean {
    try {
      this.getPostsContainer();
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Gets the posts container. Will throw if not exists. Use hasPostsContainer to determine if it exists.
   */
  public getPostsContainer(): HTMLElement {
    const el = this.doc.querySelector(this.postsSelector);
    if (!el || !(el instanceof HTMLElement)) {
      throw new AppError('unable to find posts wrapper');
    }
    return el;
  }

  /**
   * Gets individual posts using the post selector
   */
  public getAllPosts(): HTMLElement[] {
    const posts = this.getPostsContainer();
    const collection = [].slice.call(
      posts.querySelectorAll<HTMLElement>(this.postSelector)
    );
    return collection;
  }
}
